export default "__VITE_ASSET__n7K6Vmfh__"